<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row dense justify="center">
            <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                <v-radio label="Sync Installment Fee" value="inst" color="#0f2027"></v-radio>
                <v-radio label="Sync Component Fee" value="component" color="#0f2027"></v-radio>
                <v-radio label="Sync Learner Fee" value="learner" color="#0f2027"></v-radio>
            </v-radio-group>
        </v-row>
        <v-card class="box" v-if="radios == 'inst'">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Sync Leaner Component Selection
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
                        label="Academic Year" outlined persistent-hint hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" outlined persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="quota" :items="quota_list" item-text="name"
                        item-value="id" label="Quota" outlined persistent-hint
                        hint="Please Select Quota"></v-autocomplete>
                </v-col>
                <v-col sm="3" class="pt-5">
                    <v-checkbox v-model="add_new_admision_fee" label="Sync Fee of New Addmission"></v-checkbox>
                </v-col>
                <v-col sm="3" class="pt-5">
                    <v-checkbox v-model="ignore_receipt_sync_fee" label="Sync Fee If Receipt Generated"></v-checkbox>
                </v-col>
                <v-col sm="3">
                    <v-btn rounded class="button mt-6" @click="getAllReport();" :loading="loader">Sync</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-card class="box" v-if="radios == 'component'">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Sync Fees Component Amount To Learner
                    </strong>
                </v-toolbar-title>
            </v-toolbar>

            <v-row dense justify="center">
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
                        label="Academic Year" outlined persistent-hint hint="Please Select Standard"
                        @change="getComponent()"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
                        item-value="id" label="Standard" outlined persistent-hint
                        hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="quota" :items="quota_list" item-text="name"
                        item-value="id" label="Quota" outlined persistent-hint
                        hint="Please Select Quota"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="component" :items="component_list" item-text="name"
                        item-value="id" label="Component" outlined persistent-hint
                        hint="Please Select Component"></v-autocomplete>
                </v-col>
                <v-col sm="3" class="pt-5">
                    <v-checkbox v-model="add_new_admision_fee" label="Sync Fee of New Addmission"></v-checkbox>
                </v-col>
                <v-col sm="3" class="pt-5">
                    <v-checkbox v-model="ignore_receipt_sync_fee" label="Sync Fee If Receipt Generated"></v-checkbox>
                </v-col>
                <v-col sm="3">
                    <v-btn rounded class="button mt-6" @click="syncComponent();" :loading="loader">Sync Component
                        Fee</v-btn>
                </v-col>
            </v-row>

        </v-card>

        <v-card class="box" v-if="radios == 'learner'">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Sync Leaner Component Selection
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
                        label="Academic Year" outlined persistent-hint hint="Please Select Standard" @change="getComponent()"></v-autocomplete>
                </v-col>
                <v-col sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="learner" :items="learner_list" item-text="name"
                        item-value="lid" label="Learner" outlined persistent-hint
                        hint="Please Select Learner"></v-autocomplete>
                </v-col>
                <v-col sm="2" class="pt-5">
                 <v-radio-group v-model="learner_radios" mandatory row class="ma-2 no-display">
                 <v-radio label="Sync Installment Fee" value="learner_inst" color="#0f2027"></v-radio>
                <v-radio label="Sync Component Fee" value="learner_component" color="#0f2027"></v-radio>
                </v-radio-group>
                </v-col>
                 <v-col sm="3" v-if="learner_radios == 'learner_component' && component_list!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="component" :items="component_list" item-text="name"
                        item-value="id" label="Component" outlined persistent-hint
                        hint="Please Select Component"></v-autocomplete>
                </v-col>
                <v-col sm="3" class="pt-5">
                    <v-checkbox v-model="ignore_receipt_sync_fee" label="Sync Fee If Receipt Generated"></v-checkbox>
                </v-col>
                <v-col sm="3" v-if="ay && learner">
                    <v-btn rounded class="button mt-6" @click="syncLearnerFee();" :loading="loader">Sync Learner
                        Fee</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                std: null,
                header: null,
                standard_list: null,
                show: false,
                learner_info: [],
                ay_header: [],
                ay_list: [],
                ay: null,
                quota_list: [],
                quota: null,

                // extraBreadcrumbItems: [


                // ],
                breadcrumbClass: "breadcrumb-style1",
                component_list:[],
                component:null,
                add_new_admision_fee: false,
                ignore_receipt_sync_fee: false,
                radios: null,
                learner_list:null,
                learner:null,
                learner_radios:null,
            };
        },
        methods: {
            getAllReport() {
                this.loader = true;
                const data = {
                    std: this.std,
                    ay: this.ay,
                    add_new_admision_fee: this.add_new_admision_fee,
                    ignore_receipt_sync_fee: this.ignore_receipt_sync_fee,
                    quota: this.quota,
                };
                axios
                    .post("/FeesStructureInstallment/syncLernerComponentSelectionAmount", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.showSnackbar("#4caf50", "Sync Successfully..."); 
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                        this.std = null
                        this.ay = null
                        this.add_new_admision_fee = false
                        this.ignore_receipt_sync_fee = false
                        this.quota = null
                        this.component = null
                    });
            },
            getComponent(){
                const data = {
                    ay: this.ay,
                }
                 axios
                    .post("/OutstandingFees/getComponent",data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.component_list = res.data.component_list;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            syncLearnerFee(){
                if(this.learner_radios == "learner_component"){
                    if(this.component == null){
                        this.showSnackbar("#b71c1c", "Please select fee component...");
                        return
                    }
                }
                this.loader = true;
                const data = {
                    ay: this.ay,
                    learner:this.learner,
                    ignore_receipt_sync_fee: this.ignore_receipt_sync_fee,
                    component:this.component,
                    learner_radios:this.learner_radios
                };
                axios
                    .post("/FeesStructureInstallment/syncLearnerFee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.showSnackbar("#4caf50", "Sync Successfully..."); 
                        }
                        else if (res.data.flag == "NO") {
                            this.loader = false;
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                        this.learner = null
                        this.component = null
                        this.ay = null
                        this.ignore_receipt_sync_fee = false
                    });
            },
            syncComponent() {
                this.loader = true;
                const data = {
                    std: this.std,
                    ay: this.ay,
                    add_new_admision_fee: this.add_new_admision_fee,
                    ignore_receipt_sync_fee: this.ignore_receipt_sync_fee,
                    quota: this.quota,
                    component:this.component
                };
                axios
                    .post("/FeesStructureInstallment/syncComponentAmount", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.showSnackbar("#4caf50", "Sync Successfully..."); 
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.fetch_loader = false;
                        this.std = null
                        this.ay = null
                        this.add_new_admision_fee = false
                        this.ignore_receipt_sync_fee = false
                        this.quota = null
                        this.component = null
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/OutstandingFees/getStandard_sync_student_fee")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard_list = res.data.standard_list;
                            this.ay_list = res.data.ay_list;
                            this.quota_list = res.data.quota_list;
                            this.learner_list = res.data.learner_list
                           // this.component_list = res.data.component_list;
                        }else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: small;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: small;
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
</style>
